import React from 'react';
import getDealerPageProps, { PAGE_TYPES } from 'shared/routes/dealer';
import { setTargetingArguments } from 'shared/actions/globals';
import { DEALER_TABS } from 'shared/constants/navigation';
import Dealer from './Dealer';
import Layout from '../../components/Layout';
import LINKS from '../../constants/navigation';

async function action(params) {
  const { baseUrl, path, query, store } = params;
  const pageProps = await getDealerPageProps(params, PAGE_TYPES.OFFERS);

  if (!pageProps) {
    return null;
  }

  const url = `${baseUrl}${path}`.replace('//', '/');

  const {
    transportType,
    dealer,
    carsListTypes,
    currentPage,
    dealersTypes,
    title,
    description,
    isLastPage,
    isMotoSearch,
    isCommercial,
    targetingArguments,
    canonicalList,
    carsResult,
  } = pageProps;
  store.dispatch(setTargetingArguments(targetingArguments));
  return {
    chunks: ['dealer'],
    routeName: 'dealers',
    title,
    description,
    page: currentPage,
    isLastPage,
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    component: (
      <Layout withBranding navLinks={LINKS.SEARCH.avto} currentRoute={url}>
        <Dealer
          transportType={transportType}
          dealerInfo={dealer}
          tab={DEALER_TABS.OFFERS}
          carsListTypes={carsListTypes}
          currentPage={currentPage}
          dealersTypes={dealersTypes}
          url={url}
          query={query}
          // search params
          canonicalList={canonicalList}
          isMotoSearch={isMotoSearch}
          isCommercial={isCommercial}
          carsResult={carsResult}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/dealer/index.js